module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": "批量选择优先Executors",
      "element-loading-text": "请稍等···",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "作业名称",
      "prop": "type"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, _vm._l((_vm.jobNamesArray), function(item) {
    return _c('el-tag', {
      key: item,
      staticClass: "form-tags",
      attrs: {
        "type": "success"
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优先Executors",
      "prop": "jobName"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selectedExecutors),
      callback: function($$v) {
        _vm.selectedExecutors = $$v
      },
      expression: "selectedExecutors"
    }
  }, _vm._l((_vm.onlineExecutors), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), (item.container) ? _c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(" (容器组)")]) : _vm._e()])
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f6dc2db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dialog/batch_priority_dialog.vue
// module id = 1429
// module chunks = 1